import AiAgentDeploysAPI from 'dashboard/api/aiAgents/deploys';
import { createStore } from '../storeFactory';
import { throwErrorMessage } from 'dashboard/store/utils/api';

// Deploy rows are the intent record (D11/D30). create/update re-throw raw
// errors so the UI can surface the M12 readiness blockers from a 422
// ({ error, blockers: ['escalation_team_missing', ...] }).
export default createStore({
  name: 'AiAgentDeploy',
  API: AiAgentDeploysAPI,
  actions: mutations => ({
    get: async ({ commit }, { brainId }) => {
      commit(mutations.SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AiAgentDeploysAPI.get({ brainId });
        commit(mutations.SET, response.data.payload);
        return response.data.payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(mutations.SET_UI_FLAG, { fetchingList: false });
      }
    },
    create: async ({ commit }, { brainId, deploy }) => {
      commit(mutations.SET_UI_FLAG, { creatingItem: true });
      try {
        const response = await AiAgentDeploysAPI.create({ brainId, deploy });
        commit(mutations.UPSERT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { creatingItem: false });
      }
    },
    update: async ({ commit }, { brainId, id, deploy }) => {
      commit(mutations.SET_UI_FLAG, { updatingItem: true });
      try {
        const response = await AiAgentDeploysAPI.update({
          brainId,
          id,
          deploy,
        });
        commit(mutations.EDIT, response.data);
        return response.data;
      } finally {
        commit(mutations.SET_UI_FLAG, { updatingItem: false });
      }
    },
  }),
});
